import { variables } from '@styles';

export const PRIMARY_COLORS = {
  error: variables.color.semantic.negative,
  success: variables.color.semantic.positive,
  warning: variables.color.semantic.warning,
  info: variables.color.semantic.highlightLight,
};
